import parse from 'html-react-parser'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '@/components/Modal'
import type { Product } from '@/lib/api.types'

import { getProductDurationMinutes, getProductFullDescription } from '../productPresentation'
import {
  ProductModalContent,
  ProductModalDescription,
  ProductModalDuration,
  ProductModalHero,
  ProductModalInfo,
  ProductModalMedia,
  ProductModalSection,
  ProductModalTitle
} from './ProductModal.styles'

interface ProductModalProps {
  product: Product
  onClose: () => void
}

const ProductModal = ({ product, onClose }: ProductModalProps) => {
  const { t } = useTranslation()
  const fullDescription = useMemo(() => getProductFullDescription(product), [product])
  const durationMinutes = useMemo(() => getProductDurationMinutes(product), [product])
  const title = product.name
  const coverImageUrl = product.coverImage?.url || product.images?.[0]?.url || '/img/gallery01.jpg'

  return (
    <Modal onClose={onClose} showClose={true}>
      <ProductModalHero>
        <ProductModalMedia>
          <img src={coverImageUrl} alt={title} />
        </ProductModalMedia>
        <ProductModalInfo>
          <h3>{title}</h3>
          {product.description && <p>{product.description}</p>}
        </ProductModalInfo>
      </ProductModalHero>

      <ProductModalContent>
        <ProductModalSection>
          <ProductModalTitle>{t('productDescription')}</ProductModalTitle>
          <ProductModalDescription>{fullDescription ? parse(fullDescription) : '-'}</ProductModalDescription>
        </ProductModalSection>
        {durationMinutes !== null && (
          <ProductModalDuration>
            <span>{t('visitDuration')}</span>
            <strong>{t('visitDurationValue', { count: durationMinutes })}</strong>
          </ProductModalDuration>
        )}
      </ProductModalContent>
    </Modal>
  )
}

export default ProductModal
